export default "__VITE_ASSET__b92d2df2__"